module.exports = __webpack_public_path__ + "static/media/Inter-BoldItalic.86bc220a.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Inter/Inter-BoldItalic.woff
// module id = 681
// module chunks = 21